/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import tick from "../../Assets/tick.png";
import party from "../../Assets/party.png";
import defaultImage from "../../../src/Assets/fallbackimg_giftcard.png";
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import warning from "../../Assets/warning.png";
import { Link, useLocation } from "react-router-dom";
import Loader from "../../Components/Loader/Loader";
import TncRedeemNoteBox from "../Common/TncRedeemNoteBox";
import axiosInstance from "../../Common/Axios/axiosInstance";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { } from "../../Store/Slices/earnPointSlice";

import {
  CardDataSlice,
  ClientConfigurationData,
  ClientInfo,
  Dispatch,
  formatPrice,
  Navigate,
  trackEvent,
  SendMail,
  LoginV3Data,
  V3Data,
  GenerateToken,
  getImageUrl,
  ApiRespCode,
  VendorData,
} from "../Utility/Utility";
import {
  onSaveDenoCard,
  onShowThankYouReset,
} from "../../Store/Slices/cardDataSlice";
import {
  handleFailureMail,
  handleFailureSms,
  handleGenerateToken,
  sendFailureMailToAdmin,
} from "../OrderUtility/OrderUitlity";
import axiosIntegration from "../../Common/Axios/axiosIntegration";
import { onGetOrder } from "../../Store/Slices/orderSlice";
import API from "../../Common/Endpoint/serviceConstrants";

const OrderConfirmation = () => {
  const translation = getTranslationData();
  const location = useLocation();
  const vendorResponse = location?.state;
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const cardData = CardDataSlice();
  const orderDetails = cardData?.OrderData;
  const [supplierMaster, setSupplierMaster] = useState();
  const updatedOrderData = useSelector((state) => state?.orderReducer?.updatedOrderData);
  const supplierName =
    updatedOrderData?.supplierCode && Array.isArray(supplierMaster)
      ? supplierMaster.find(
        (item) => item?.code === updatedOrderData?.supplierCode
      )?.supplierName || "N/A"
      : "N/A";

  const productData = useSelector((state) => state?.productDataReducer);
  const sendMailState = SendMail();
  const v3LoginData = LoginV3Data();
  const cardListData = useSelector((state) => state.clientConfigDataReducer);
  const v3Data = V3Data();
  const generateToken = GenerateToken();
  const totalValue = orderDetails?.orderItems?.reduce(
    (acc, card) => acc + (card?.denomination || 0) * (card?.quantity || 0),
    0,
  );
  const tncComponent = (
    <TncRedeemNoteBox translation={translation} productData={productData} />
  );
  const totalPaid = orderDetails?.orderItems?.reduce(
    (acc, card) => acc + (parseInt(card?.you_pay) || 0) * (card?.quantity || 0),
    0,
  );
  const categoryData = useSelector(
    (state) => state.userRoleSliceReducer.categoryData,
  );

  const clientConfig = ClientConfigurationData();
  const clientInfo = ClientInfo();
  const clientConfigurations = clientInfo?.clientData?.clientConfigurations;
  const adminEmail = clientConfigurations?.find(
    (item) => item.configKey === "superAdminEmail",
  )?.description;

  const navigate = Navigate();
  const dispatch = Dispatch();
  const handleRetrieveCode = (productData, orderId) => {
    if (productData) {
      trackEvent("coupon_redeem", {
        currency: "INR",
        value: productData?.total,
        // discount: order?.customerDis,
        // item_brand: productData?.name,
        gift_card_value: productData?.denomination * productData?.quantity,
        // event: [
        //   order?.products?.map(item => ({
        //     item_id: item.sku,
        //     item_brand: item.name,
        //     item_name: item.name,
        //     affiliation: "IDFC Store",
        //     item_category: "Gift Card",
        //     item_category: order?.category,
        //     item_image: item?.image,
        //     item_url: order?.url,
        //     price: item?.denomination * item?.qty,
        //     gift_card_points: item?.denomination,
        //     quantity: item?.qty,
        //     expriy_date: item?.expireDate,

        //   }))
        // ]
      });
      dispatch(onSaveDenoCard({ productData, orderId }));
      clientConfig?.otpRedeem ? navigate("/otp") : navigate(`/order-detail`);
    }
  };
  // // product id from orderDetails
  // const productId = orderDetails?.id;

  // // Get client product mapping array from Redux
  // const ClientProductMappingData = useSelector(
  //   (state) =>
  //     state?.ClientProductMappingbyIdReducer?.data?.[0]?.clientProductMapping
  // );

  // Find the matching product mapping
  const productMapping = productData?.data;

  // Extract convenience fee % and GST %
  const convenienceFeePercent = Number(productMapping?.convenienceFee) || 0;
  const gstPercent = Number(productMapping?.gst) || 0;
  const customerdis = Number(productMapping?.customerDiscount) || 0;

  useEffect(() => {
    trackEvent("page_browse", {
      page_title: "order confirmation",
      page_url: window.location.href,
    });

    const selectedCard = localStorage.getItem("RewardWidget");
    const cardData = cardListData?.clientConfigData?.cards?.find(
      (card) => card.cardId === selectedCard,
    );
    let rewardPoints = 0;
    if (cardData) {
      rewardPoints = Math.floor(
        (orderDetails?.totalPayableAmount / cardData.perRs) *
        cardData.standardPoints *
        (cardData.bonusPoints / cardData.standardPoints + 1),
      );
    }

    const orderItems = orderDetails?.orderItems || [];

    trackEvent("purchase", {
      value: orderDetails?.totalPayableAmount,
      currency: "INR",
      // discount: (productMapping?.reduce((sum, item) => {
      //   const discountAmount = (item.denomination * (item.customerDis || 0)) / 100;
      //   return sum + discountAmount;
      // }, 0) || 0),
      discount: productMapping?.customerDiscount || 0,
      total_gift_card_points: orderDetails?.orderItems.reduce(
        (sum, it) =>
          sum + Number(it?.denomination || 0) * Number(it?.quantity || 0),
        0,
      ),
      convenience_fee: productMapping?.convenienceFee || 0,
      //  burn_points: orderDetails?.burnPoints,
      card_name: selectedCard,
      reward_points: rewardPoints,
      transaction_id: orderDetails?.orderId,
      items: orderItems.map((item) => {
        return {
          item_brand: orderDetails?.name,
          item_name: orderDetails?.name,
          affiliation: "IDFC Store",
          item_category: "Gift Card",
          item_category2: categoryData.find(
            (cat) => cat.id === productData?.data.categoryId,
          )?.name,
          item_image: orderDetails?.cardImage,
          // earn_point: item?.earnPoints ?? orderDetails?.earnPoints,
          price: Number(item?.you_pay),
          quantity: item?.quantity,
          gift_card_points: item?.denomination,
          item_id: orderDetails?.id,
          item_url: window.location.href,
        };
      }),
    });

    if (cardData?.show) {
      navigate("/");
    }
    dispatch(onShowThankYouReset());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchSupplierMaster = async () => {
    try {
      const res = await axiosInstance.get(API.supplier_master);
      const payload = res?.data?.response || res?.data || [];
      setSupplierMaster(payload);
    } catch (err) {
      console.error("Error fetching supplier master:", err);
    }
  };

  useEffect(() => {
    if (cardData?.failure) {
      handleGenerateToken(dispatch, v3Data);
      dispatch(onGetOrder());
      fetchSupplierMaster();
    }
  }, []);
  // Fire failure email exactly once per order navigation
  useEffect(() => {
    if (!cardData?.failure) return;

    const orderId =
      orderDetails?.orderId || orderDetails?.orderID || orderDetails?.id;
    if (!orderId) return;

    const sentKey = `failure_mail_sent_${orderId}`;
    const alreadySent = sessionStorage.getItem(sentKey) === "1";
    if (alreadySent) return;

    const firstItem = orderDetails?.orderItems?.[0] || {};
    const productForEmail = {
      name: orderDetails?.name,
      clientCommission: orderDetails?.id,
      image: orderDetails?.cardImage,
      denomination: firstItem?.denomination,
      quantity: firstItem?.quantity,
      total: totalPaid,
      customerDis: firstItem?.you_pay,
    };
    const orderForEmail = {
      orderId: orderId,
      products: orderDetails?.orderItems,
      totalBurn: orderDetails?.burnPoints,
      amount: orderDetails?.totalPayableAmount,
    };
    const tokenCreated = generateToken?.status_code === ApiRespCode.v3Create;
    if (tokenCreated) {
      axiosIntegration.defaults.headers["access-token"] =
        `${generateToken?.data?.accessToken}`;
      axiosIntegration.defaults.headers["ClientCode"] = `${v3Data.ClientCode}`;
      axiosIntegration.defaults.headers["PartnerCode"] =
        `${v3Data.partnerCode}`;
      try {
        handleFailureMail(
          dispatch,
          sendMailState,
          v3LoginData,
          productForEmail,
          orderForEmail,
          clientInfo,
          clientConfig,
          orderDetails,
        );
        sendFailureMailToAdmin(
          dispatch,
          sendMailState,
          productForEmail,
          orderForEmail,
          adminEmail,
          vendorResponse,
          supplierName,
          v3LoginData
        );
        handleFailureSms(
          dispatch,
          sendMailState,
          v3Data,
          v3LoginData,
          orderForEmail,
          productForEmail
        );

        sessionStorage.setItem(sentKey, "1");
      } catch (e) {
        // swallow errors to avoid blocking UI
        console.error("Failure mail trigger error", e);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardData?.failure, generateToken?.data]);

  return (
    <>
      <ScrollToTop />
      {false ? (
        <Loader />
      ) : (
        <div className="bg-light-grey minhight2">
          <section
            className={`py-xl-3 pt-1 pb-2 mar-4 bg-white ${isMobile ? "mobile-view" : "desktop-hide"
              }`}
          >
            <div className="container-fluid">
              <div className="m-xl-n3 m-md-n2 m-n1">
                <div className="p-md-2 p-1 order_conf text-center">
                  {cardData.failure
                    ? translation?.order_failed
                    : translation?.orderConfirmation}
                </div>
              </div>
            </div>
          </section>

          <section className={`pt-1 pl-1 pad-1 ${isMobile ? "" : "mr-tb"}`}>
            <div className="card-container p-2">
              <div className="row justify-content-center">
                <div className="col-md-4 col-12 card-conf">
                  {cardData.failure ? (
                    <div className="order-failed-container">
                      <div className="order-failed-box">
                        <div className="order-failed-header bottom-b">
                          <img className="icon-1" src={warning} alt="warning" />
                          <div className="head-text">
                            <span className="head-text-1">
                              {translation?.order_failed}
                            </span>
                            <span className="head-subtext">
                              {translation?.gift_card_purchase}
                            </span>
                          </div>
                        </div>
                        <Link to="/contact-us" className="contact-link">
                          {translation?.contactSupport}
                        </Link>
                      </div>

                      <div className="order-cancel-box">
                        <span>{translation?.orderCancelled}</span>
                      </div>

                      {isMobile && (
                        <h4 className="order-label">
                          {translation?.your_order_text}
                        </h4>
                      )}
                    </div>
                  ) : (
                    <>
                      <div className="thanku-card">
                        <img className="party" src={party} alt="Party" />
                        <div className="bg-pink">
                          <div className="d-flex justify-content-start p-2">
                            {cardData.failure ? (
                              <i className="fa fa-times fail-icon"></i>
                            ) : (
                              <img
                                className="w-50px tick"
                                src={tick}
                                alt="Tick"
                              />
                            )}
                            <div className="thankyoubox2">
                              <p className="onep">
                                {cardData.failure
                                  ? translation.order_failure
                                  : translation?.thankYou}
                              </p>
                              {cardData.failure ? (
                                translation.e_gift_card_purchase
                              ) : (
                                <p className="secondppp">
                                  {translation?.giftCardPurchaseSuccess}
                                </p>
                              )}
                            </div>
                          </div>
                          <hr className="hz-line" />
                          <div className="d-flex justify-content-between mb-2">
                            <div className="thankyoubox3">
                              <p className="thank-ans">
                                {orderDetails?.orderId}
                              </p>
                              <p className="thank-qns">
                                {translation?.orderNumber}
                              </p>
                            </div>
                            <div className="thankyoubox3">
                              <p className="thank-ans">
                                {/* show points only if > 0 */}
                                {orderDetails?.burnPoints > 0 &&
                                  `${Math.round(
                                    orderDetails?.burnPoints,
                                  )} Pts `}
                                {/* add + only if burnPoints > 0 */}
                                {orderDetails?.burnPoints > 0 ? "+ " : ""}₹
                                {formatPrice(orderDetails?.totalPayableAmount)}
                              </p>

                              <p className="thank-qns">
                                {translation?.orderAmount}
                              </p>
                            </div>

                            <div className="thankyoubox3">
                              {orderDetails?.burnPoints <= 0 &&
                                parseInt(orderDetails?.earnPoints) > 0 && (
                                  <>
                                    <p className="thank-ans bold">
                                      {orderDetails?.burnPoints <= 0
                                        ? parseInt(orderDetails?.earnPoints) > 0
                                          ? `${orderDetails?.earnPoints} Pts`
                                          : `0 Pts`
                                        : `0 Pts`}
                                    </p>

                                    <span className="thank-qns">
                                      {translation?.bonusPoints}{" "}
                                    </span>
                                    <p className="thank-qns">
                                      {translation?.earned}
                                    </p>
                                  </>
                                )}
                            </div>

                            <div className="thankyoubox3"></div>
                          </div>
                        </div>
                        <div className="thku-page-b thanku-card">
                          <div className="d-flex justify-content-between pb-md-1">
                            <div className="thankyoubox3">
                              <Link to="/">
                                <p className="keep-thank">
                                  {translation?.keepShoppingEarnMore}
                                </p>
                              </Link>
                            </div>
                            <div className="thankyoubox3">
                              <p className="onep" onClick={() => navigate("/")}>
                                <i
                                  className="fa fa-angle-right "
                                  aria-hidden="true"
                                ></i>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className={`loyo ${isMobile ? "bg-white" : "card-bg"}`}
                      >
                        <p className="dis-thank">
                          {cardData.failure
                            ? translation?.orderCancelled
                            : translation?.orderDetailsMessage}
                        </p>
                      </div>
                    </>
                  )}
                  {!isMobile && tncComponent}
                </div>

                <div
                  className={`col-lg-4 col-12 mt-md-0 mrt-2 card-value pt-pb ${isMobile ? "bg-white" : ""
                    }`}
                >
                  <div className="side-newthank mb-0 mb-md-4 pt-2">
                    <div className="d-flex w-100 h-100 justify-content-center">
                      <Link>
                        <div className="w-100 order_confirmation_img_div">
                          <img
                            className="order_confirmation_img"
                            alt="card-image"
                            src={
                              getImageUrl(orderDetails?.cardImage) ||
                              defaultImage
                            }
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = defaultImage;
                            }}
                          />
                        </div>
                      </Link>
                    </div>
                  </div>
                  <div className="card card_main_box mt-3">
                    <div className="card-body amazonPay_e_Gift_Card">
                      <div className="container pt-2">
                        <h5 className="card-title">{orderDetails?.cardName}</h5>
                        <div className="row header-row custom-inner-border">
                          <div
                            className={` ${clientInfo?.otpConfig === 1 ? "col-3" : "col-4 "
                              }  t_head py-2 text-center`}
                          >
                            <strong>{translation?.value}</strong>
                          </div>
                          <div
                            className={` ${clientInfo?.otpConfig === 1 ? "col-2" : "col-4"
                              }  t_head py-2 text-center`}
                          >
                            <strong>{translation?.quantity}</strong>
                          </div>
                          <div
                            className={` ${clientInfo?.otpConfig === 1 ? "col-4" : "col-4"
                              }  t_head py-2 text-center`}
                          >
                            <strong>{translation?.youPaid}</strong>
                          </div>
                          {clientInfo?.otpConfig === 1 ? (
                            <div
                              className={` ${clientInfo?.otpConfig === 1 ? "col-3" : "col-4"
                                } lines3_col_4 t_head py-2 text-center`}
                            >
                              <strong>{translation?.code}</strong>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        {orderDetails?.orderItems?.map((card, index) =>
                          card?.quantity > 0 ? (
                            <div
                              className="row card-row custom-inner-border"
                              key={index}
                            >
                              <div
                                className={`${clientInfo?.otpConfig === 1
                                  ? "col-3"
                                  : "col-4"
                                  }  t_body py-2 text-center tabledata`}
                              >
                                ₹ {parseInt(card?.denomination)}
                              </div>
                              <div
                                className={`${clientInfo?.otpConfig === 1
                                  ? "col-2"
                                  : "col-4"
                                  } t_body py-2 text-center tabledata`}
                              >
                                {card?.quantity}
                              </div>{" "}
                              <div
                                className={`${clientInfo?.otpConfig === 1
                                  ? "col-4"
                                  : "col-4"
                                  }  t_body py-2 text-center tabledata`}
                              >
                                ₹ {formatPrice(card?.total)}
                              </div>
                              {clientInfo?.otpConfig === 1 ? (
                                <div
                                  className={`${clientInfo?.otpConfig === 1
                                    ? "col-3"
                                    : "col-4"
                                    } t_body py-2 tabledata get-code-wrapper`}
                                >
                                  <button
                                    className={`get-code-btn ${cardData.failure ? "disabled-btn" : ""
                                      }`}
                                    disabled={cardData.failure}
                                    onClick={() =>
                                      handleRetrieveCode(
                                        card,
                                        orderDetails?.orderId,
                                      )
                                    }
                                  >
                                    {translation?.getCode}
                                  </button>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          ) : (
                            <></>
                          ),
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="card card_main_box mt-3 bg-white total-am-bg">
                    <div className="card-body">
                      {(() => {
                        let totalDenomination = 0;
                        let totalQuantity = 0;
                        let basePayableAmount = 0;
                        let convenienceFeeAmount = 0;
                        let gstAmount = 0;

                        const orderItems = orderDetails?.orderItems || [];

                        orderItems.forEach((item) => {
                          const qty = item.quantity || 0;
                          const denomination = item.denomination || 0;
                          const youPay = item.you_pay || 0;

                          totalDenomination += denomination * qty;
                          totalQuantity += qty;
                          basePayableAmount += youPay * qty;

                          const convFeePerItem =
                            (youPay * convenienceFeePercent) / 100;
                          convenienceFeeAmount += convFeePerItem * qty;

                          const gstPerItem =
                            (convFeePerItem * gstPercent) / 100;
                          gstAmount += gstPerItem * qty;
                        });
                        const totalDiscount =
                          (totalDenomination * customerdis) / 100;

                        //setTotalDiscount(totalDiscount);
                        const totalPayableAmount =
                          totalDenomination -
                          totalDiscount +
                          convenienceFeeAmount +
                          gstAmount;

                        return (
                          <>
                            {/* Total Giftcards */}
                            <div className="d-flex justify-content-between jlkk pb-2">
                              <div className="mr-4 lsss2">
                                {totalQuantity} {translation?.giftCard}
                                {totalQuantity > 1 ? "s" : ""}
                              </div>
                              <div className="lsss3">
                                ₹{totalDenomination.toLocaleString()}
                              </div>
                            </div>

                            {customerdis > 0 && (
                              <div className="d-flex justify-content-between jlkk pb-2">
                                <div className="mr-4 lsss2">
                                  {translation?.discount}
                                </div>
                                <div className="lsss3">
                                  ₹{formatPrice(totalDiscount)}
                                </div>
                              </div>
                            )}

                            {/* Convenience Fee + GST */}
                            {(convenienceFeeAmount > 0 || gstAmount > 0) && (
                              <div className="d-flex justify-content-between jlkk pb-2">
                                <div className="mr-4 lsss2">
                                  {convenienceFeeAmount > 0 && (
                                    <>
                                      <span className="d-block">
                                        {translation?.convenience_fe}
                                      </span>
                                      <span>{convenienceFeePercent}%</span>
                                    </>
                                  )}
                                  {gstAmount > 0 && (
                                    <span>{translation?.plus_gst}</span>
                                  )}
                                </div>
                                <div className="lsss3">
                                  ₹
                                  {formatPrice(
                                    convenienceFeeAmount + gstAmount,
                                  )}
                                </div>
                              </div>
                            )}

                            {/* Total Amount */}
                            <div className="d-flex justify-content-between jlkk">
                              <div className="mr-4 lsss3 lssss4">
                                {translation?.totalAmount}
                              </div>
                              <div className="lsss3">
                                ₹{formatPrice(totalPayableAmount)}
                              </div>
                            </div>
                          </>
                        );
                      })()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {isMobile && tncComponent}
          </section>
        </div>
      )}
    </>
  );
};

export default OrderConfirmation;
